import { toast } from 'react-toastify';
import apiClient from '../service/apiClient';
import { Page, ResponseError } from '../type/type';
import { create } from 'zustand';
import { isAxiosError } from 'axios';

export interface ITracking {
  description: string;
  parameter: string;
  url: string;
  customerName: string;
}

export interface ITrackingPerformance {
  trkId: string;
  description: string;
  kakaoId: string;
  username: string;
  telNo: string;
  userIp: string;
  trackedAt: string;
  newUser: boolean;
}
interface TrackingResponse extends Page {
  content: ITracking[];
}

interface TrackingPerformanceResponse extends Page {
  content: ITrackingPerformance[];
}

type TrackingData = {
  // 로딩
  postTrackingLoading: boolean;
  updateTrackingLoading: boolean;

  trackingList: ITracking[];
  trackingPage: Page | null;

  trackingPerformanceList: ITrackingPerformance[];
  trackingPerformancePage: Page | null;
};

type TrackingAction = {
  getTracking: (sort?: string, page?: number, size?: number) => Promise<void>;

  getTrackingPerformance: (
    sort?: string,
    page?: number,
    size?: number,
    newUser?: string,
    startDate?: string,
    endDate?: string,
    trkId?: string
  ) => Promise<void>;

  // 트래킹 등록
  PostTracking: (description: string, parameter: string) => Promise<void>;

  // 트래킹 수정
  UpdateTracking: (description: string, parameter: string) => Promise<void>;
};

export const useTracking = create<TrackingData & TrackingAction>(
  (set, get) => ({
    postTrackingLoading: false, //트래킹 등록 로딩 상태
    updateTrackingLoading: false, //트래킹 수정 로딩 상태
    //초기 상태 설정
    trackingList: [],
    trackingPage: null,
    trackingPerformanceList: [],
    trackingPerformancePage: null,

    //오늘의 운세 트래킹 목록 가져오기

    getTracking: async (sort = 'createdAt,desc', page = 0, size = 100) => {
      try {
        const response = await apiClient.get<TrackingResponse>('/trackingUrl', {
          params: {
            sort,
            page,
            size,
          },
        });
        const { content, ...rest } = response.data;

        set({
          trackingList: content,
          trackingPage: rest,
        });
      } catch (error) {
        console.error('API 요청 실패:', error);
        toast.error('오늘의 운세 통계 데이터를 가져오지 못했습니다.');
      }
    },

    //트래킹 실적 목록 가져오기
    getTrackingPerformance: async (
      sort = 'createdAt,desc',
      page = 0,
      size = 20,
      newUser,
      startDate,
      endDate,
      trkId
    ) => {
      try {
        const url = trkId ? `/user-track/${trkId}` : '/user-track';
        const response = await apiClient.get<TrackingPerformanceResponse>(url, {
          params: {
            sort,
            page,
            size,
            newUser,
            startDate,
            endDate,
          },
        });
        const { content, ...rest } = response.data;

        set({
          trackingPerformanceList: content,
          trackingPerformancePage: rest,
        });
      } catch (error) {
        console.error('API 요청 실패:', error);
        toast.error('트래킹 실적 데이터를 가져오지 못했습니다.');
      }
    },

    // 트래킹 등록
    PostTracking: async (description, parameter) => {
      set({ trackingList: [] });
      set({ postTrackingLoading: true });
      try {
        await apiClient.post('/trackingUrl', {
          description,
          parameter,
        });
        toast.success('트래킹이 추가되었습니다.');

        await get().getTracking();
      } catch (error) {
        if (isAxiosError<ResponseError>(error)) {
          toast.error(error.response?.data.errorMsg);
        } else {
          console.error('API 요청 실패:', error);
          toast.error('트래킹을 추가하지 못했습니다.');
        }
      }
      set({ postTrackingLoading: false });
    },

    // 트래킹 수정
    UpdateTracking: async (description, parameter) => {
      set({ trackingList: [] });
      set({ updateTrackingLoading: true });
      try {
        await apiClient.patch('/trackingUrl', {
          description,
          parameter,
        });
        toast.success('트래킹이 수정되었습니다.');

        await get().getTracking();
      } catch (error) {
        if (isAxiosError<ResponseError>(error)) {
          toast.error(error.response?.data.errorMsg);
        } else {
          console.error('API 요청 실패:', error);
          toast.error('트래킹을 수정하지 못했습니다.');
        }
      }
      set({ updateTrackingLoading: false });
    },
  })
);
